import script from "./SharesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SharesTable.vue?vue&type=script&setup=true&lang=js"

import "./SharesTable.vue?vue&type=style&index=0&id=524ee64a&scoped=true&lang=css"
import "./SharesTable.vue?vue&type=style&index=1&id=524ee64a&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524ee64a"]])

export default __exports__